import { render, staticRenderFns } from "./CustomerDetailsPage.vue?vue&type=template&id=03fbc442&scoped=true&"
import script from "./CustomerDetailsPage.vue?vue&type=script&lang=js&"
export * from "./CustomerDetailsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03fbc442",
  null
  
)

export default component.exports